const API_URL = process.env.REACT_APP_API_URL;

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
}

export const assignToClient = async (memberId, data) => {
  const res = await fetch(`${API_URL}/business-fitness/clients/${memberId}/assign`, {
    method: 'POST', headers: getAuthHeaders(), body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to assign');
  return res.json();
};

export const unassignFromClient = async (memberId, assignmentId) => {
  const res = await fetch(`${API_URL}/business-fitness/clients/${memberId}/assignments/${assignmentId}`, {
    method: 'DELETE', headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to unassign');
  return res.json();
};

export const getClientSchedule = async (memberId, params = {}) => {
  const qs = new URLSearchParams(params).toString();
  const url = `${API_URL}/business-fitness/clients/${memberId}/schedule${qs ? '?' + qs : ''}`;
  const res = await fetch(url, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to fetch schedule');
  return res.json();
};

export const getClientProgress = async (memberId) => {
  const res = await fetch(`${API_URL}/business-fitness/clients/${memberId}/progress`, {
    headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to fetch progress');
  return res.json();
};

export const getClientActivitySummary = async (memberId) => {
  const res = await fetch(`${API_URL}/business-fitness/clients/${memberId}/activity-summary`, {
    headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to fetch activity');
  return res.json();
};

export const getClientNutritionPlans = async (memberId) => {
  const res = await fetch(`${API_URL}/business-fitness/clients/${memberId}/nutrition-plans`, {
    headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to fetch nutrition plans');
  return res.json();
};

export const createClientNutritionPlan = async (memberId, data) => {
  const res = await fetch(`${API_URL}/business-fitness/clients/${memberId}/nutrition-plan`, {
    method: 'POST', headers: getAuthHeaders(), body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to create nutrition plan');
  return res.json();
};

export const getAvailablePrograms = async (search = '') => {
  const qs = search ? `?search=${encodeURIComponent(search)}` : '';
  const res = await fetch(`${API_URL}/business-fitness/programs/available${qs}`, {
    headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to fetch programs');
  return res.json();
};

export const getAvailableWorkouts = async (search = '') => {
  const qs = search ? `?search=${encodeURIComponent(search)}` : '';
  const res = await fetch(`${API_URL}/business-fitness/workouts/available${qs}`, {
    headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to fetch workouts');
  return res.json();
};
